import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import DashboardView from "@/views/DashboardView.vue"
import LoginView from "@/views/app/LoginView.vue"
import FinancialInputsView from "@/views/contracts/FinancialInputsView.vue"
import MdaSignalsView from "@/views/data/signals/MdaSignalsView.vue"
import SolarReadingsView from "@/views/data/readings/SolarReadingsView.vue"
import MetersReadingsView from "@/views/data/readings/MetersReadingsView.vue"
import DcsReadingsView from "@/views/data/readings/DcsReadingsView.vue"
import FormulasView from "@/views/contracts/FormulasView.vue"
import Coefficients from "@/views/contracts/CoefficientsView.vue"
import PerformanceView from "@/views/PerformanceView.vue"
import UnitsView from "@/views/common/UnitsView.vue"
import LogsView from "@/views/app/LogsView.vue"
import SettingsView from "@/views/app/SettingsView.vue"
import AppModeView from "@/views/app/AppModeView.vue"
import NotFoundView from "@/views/app/NotFoundView.vue"
import ReportsView from "@/views/common/ReportsView.vue"
import DocumentationView from "@/views/app/DocumentationView.vue"
import ProjectDetailsView from "@/views/app/ProjectDetailsView.vue"
import ChangePasswordView from "@/views/app/ChangePasswordView.vue"
import UsersView from "@/views/app/UsersView.vue"
import RolesView from "@/views/app/RolesView.vue"
import ManualEntriesView from "@/views/app/ManualEntriesView.vue"
import HealthCheckView from "@/views/app/HealthCheckView.vue"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "dashboard",
    component: DashboardView,
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/change_password",
    name: "change-password",
    component: ChangePasswordView,
  },
  {
    path: "/users",
    name: "users",
    component: UsersView,
    meta: { permission: "users:read" },
  },
  {
    path: "/roles",
    name: "roles",
    component: RolesView,
    meta: { permission: "roles:read" },
  },
  {
    path: "/manual-entries",
    name: "manual-entries",
    component: ManualEntriesView,
    meta: { permission: "manual_entries:read" },
  },
  {
    path: "/health-check",
    name: "health-check",
    component: HealthCheckView,
    meta: { permission: "health_check:read" },
  },
  {
    path: "/mda_signals",
    name: "mda_signals",
    component: MdaSignalsView,
  },
  {
    path: "/solar_readings",
    name: "solar_readings",
    component: SolarReadingsView,
  },
  {
    path: "/mda_readings",
    name: "mda_readings",
    component: MetersReadingsView,
  },
  {
    path: "/dcs_readings",
    name: "dcs_readings",
    component: DcsReadingsView,
  },
  {
    path: "/coefficients",
    name: "coefficients",
    component: Coefficients,
  },
  {
    path: "/formulas",
    name: "formulas",
    component: FormulasView,
  },
  {
    path: "/financial_inputs",
    name: "financial_inputs",
    component: FinancialInputsView,
  },
  {
    path: "/performance",
    name: "performance",
    component: PerformanceView,
    meta: { permission: "ppm:read" },
  },
  {
    path: "/units",
    name: "units",
    component: UnitsView,
  },
  {
    path: "/project",
    name: "project",
    component: ProjectDetailsView,
  },
  {
    path: "/reports",
    name: "reports",
    component: ReportsView,
    meta: { permission: "reports:read" },
  },
  {
    path: "/logs",
    name: "logs",
    component: LogsView,
  },
  {
    path: "/documentation",
    name: "documentation",
    component: DocumentationView,
  },
  {
    path: "/settings",
    name: "settings",
    component: SettingsView,
  },
  {
    path: "/app_mode",
    name: "app_mode",
    component: AppModeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/app/AboutView.vue"),
  },
  {
    // See https://router.vuejs.org/guide/migration/#removed-star-or-catch-all-routes
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: NotFoundView,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
